<template>
  <div id="invoice-details-view">
    <div class="grid-row">
      <div class="column">
        <div class="invoice-details-view-header">
          <h1>{{$_('invoice_detail', {tnfac, tdate: $dateformat(tdate), tmonttc})}}</h1>
        </div>
      </div>
    </div>
    <InvoiceDetailsList />
  </div>
</template>

<script>

import InvoiceDetailsList from '@/modules/facture/components/InvoiceDetailsList';

export default {
    data() {
      return {
        tnfac: '',
        tdate: '',
        tmonttc: ''
      }
    },
    created() {

      if(localStorage.getItem('satabapp-text') === null) {

        localStorage.setItem('satabapp-text', JSON.stringify({
          tnfac: this.$route.params.invoice_id,
          tdate: this.$route.params.invoice_date,
          tmonttc: this.$route.params.invoice_amount
        }));

        this.tnfac = this.$route.params.invoice_id;
        this.tdate = this.$route.params.invoice_date;
        this.tmonttc = this.$route.params.invoice_amount;

      } else {

        this.tnfac = JSON.parse(localStorage.getItem('satabapp-text')).tnfac;
        this.tdate = JSON.parse(localStorage.getItem('satabapp-text')).tdate;
        this.tmonttc = JSON.parse(localStorage.getItem('satabapp-text')).tmonttc;
      }
    },
    components: {
      InvoiceDetailsList
    }
}
</script>

<style>

</style>